import { LocalStorage } from '../../class/local-storage';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Device } from '@capacitor/device';
import { CONSTANTS } from 'src/app/config/constants';
import { Language } from 'src/app/enum/language';

@Injectable({
	providedIn: 'root'
})
export class TranslateManagerService {

	private subject = new Subject<string>();

	constructor() { }

	public setLanguage(language: string) {
		this.subject.next(language);
	}

	public listener(): Observable<string> {
		return this.subject.asObservable();
	}

	public async getOSLanguage(): Promise<string> {
		try {
			const osLanguage = await Device.getLanguageCode();
			const [code, _] = osLanguage.value.split('-');
			return this.getLanguages().find(language => language === code) || Language.ENGLISH;
		} catch (error) {
			return 'en'
		}
	}

	public getLanguages() {
		return [
			Language.ENGLISH,
			Language.SPANISH,
			Language.FRENCH,
			Language.PORTUGUESE
		];
	}

	public getCurrentLanguage() {
		let result = LocalStorage.get(CONSTANTS.localStorage.keys.language);
		if (result) {
			result = this.getLanguages().find(item => item === result);
		}
		return result ?? Language.ENGLISH;
	}

}
